<template>
  <v-app-bar height="80" class="pa-0" app elevate-on-scroll>
    <v-img
      max-height="50"
      max-width="50"
      contain src="../assets/logo_small.png"
      class="mr-4 mb-4 hidden-sm-and-up"
    ></v-img>
    <v-img
      max-height="72"
      max-width="200"
      contain src="../assets/logo.png"
      class="mr-4 mb-4 hidden-xs-only"
    ></v-img>
    <v-tabs class="links" :value="$route">
      <v-tab
        class="hidden-tab"
        to="/"
      >
      </v-tab>
      <v-tab
        v-for="(item, i) in navItems"
        :key="i"
        :to="item.path"
        class="mt-2"
      >
        <v-icon size="20">{{item.icon}}</v-icon>
        <v-card-text class="text-body-1 font-weight-bold px-1 hidden-xs-only">
          {{item.label}}
        </v-card-text>
      </v-tab>
    </v-tabs>
    <v-spacer></v-spacer>
    <v-menu offset-y>
      <v-toolbar flat class="text--secondary" style="user-select: none;">
        {{$store.getters.user.userName}}
      </v-toolbar>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="mt-2"
          outlined
        >
          <v-icon size="36">mdi-account</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in menuItems"
          :key="index"
          @click="executeAction(item)"
        >
          <v-list-item-action class="pl-2 mr-4 my-0">
            <v-icon class="pa-0">{{item.icon}}</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
const helpUrl = 'https://www.beyondlabz.com/support';
const communityUrl = 'https://community.beyondlabz.com/';

export default {
  name: 'Navigation',
  methods: {
    executeAction(item) {
      if (item.action) {
        item.action();
      }
      if (item.path) {
        this.$router.push(item.path);
      }
    },
    logout() {
      const url = 'https://portal.beyondlabz.com/auth/logout';
      this.$http.post(url)
        .then((resp) => {
          if (resp.status === 200) {
            console.log(resp);
            this.$store.commit('SET_USER', {});
            this.$router.push('/login');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  data() {
    return {
      navItems: [
        {
          label: 'Labs',
          icon: 'mdi-flask-empty',
          path: '/labs',
        },
        {
          label: 'Activities',
          icon: 'mdi-clipboard-text',
          path: '/activities',
        },
      ],
      menuItems: [
        {
          label: 'License Manager',
          icon: 'mdi-lock-open',
          path: '/license',
        },
        {
          label: 'Downloads',
          icon: 'mdi-download',
          path: '/downloads',
        },
        {
          label: 'Help',
          icon: 'mdi-help-box',
          action: () => { window.open(helpUrl, '_blank'); },
        },
        {
          label: 'Ask the Community',
          icon: 'mdi-forum',
          action: () => { window.open(communityUrl, '_blank'); },
        },
        {
          label: 'Change password',
          icon: 'mdi-form-textbox-password',
          path: '/password',
        },
        {
          label: 'Log out',
          icon: 'mdi-logout',
          action: this.logout,
        },
      ],
    };
  },
};
</script>

<style scoped>
.hidden-tab{
  visibility: hidden;
  max-width: 0;
  min-width: 0;
  padding: 0;
  margin: 0;
}
</style>
